
import TraversTree from './Helpers/TreeTravers.js'

export default {
    name: 'PageContent',
    props: {
        pageContent: {
            type: String,
            default: () => null
        },
        highlights: {
            type: Array,
            default: () => null
        },
        img: String,
        isText: Boolean,
        isVisible: Boolean,
        source: Object
    },
    computed: {
        content () {
            if (!this.pageContent || !this.pageContent.trim().length) {
                return ''
            }

            const content = this.setUpHighlights(this.pageContent)

            return content
        }
    },
    methods: {
        getClass (color) {
            return [{
                color: 'redHighlight',
                class: 'bg-red-300/50 text-red-300/50'
            }, {
                color: 'yellowHighlight',
                class: 'bg-yellow-300/50 text-yellow-300/50'
            }, {
                color: 'blueHighlight',
                class: 'bg-blue-300/50 text-blue-300/50'
            }, {
                color: 'greenHighlight',
                class: 'bg-green-300/50 text-green-300/50'
            }, {
                color: 'purbleHighlight',
                class: 'bg-purple-300/50 text-purple-300/50'
            }].find(c => c.color === color).class
        },
        getBorderClass (color) {
            return [{
                color: 'redHighlight',
                class: 'border-red-600'
            }, {
                color: 'yellowHighlight',
                class: 'border-yellow-600'
            }, {
                color: 'blueHighlight',
                class: 'border-brand-500'
            }, {
                color: 'greenHighlight',
                class: 'border-green-600'
            }, {
                color: 'purbleHighlight',
                class: 'border-purple-600'
            }].find(c => c.color === color).class
        },
        setUpHighlights (content) {
            if (!this.highlights || !this.highlights.length || !this.isVisible) {
                return content
            }

            const pageHighlights = this.highlights

            const dom = document.createElement('div')
            dom.innerHTML = content
            const highlights = [...pageHighlights]

            const highlightMap = {}
            highlights.forEach((h) => {
                const start = parseInt(h.start_id.split('_').at(-1))
                const end = parseInt(h.end_id.split('_').at(-1))
                for (let i = start; i <= end; i++) {
                    highlightMap[i] = {
                        color: h.color_class,
                        id: h.id,
                        pageId: h.page_id,
                        note: h.note
                    }
                }
            })
            const wordBoxLimit = new Map()
            highlights.forEach((h) => {
                wordBoxLimit.set(h.id, 3)
            })
            TraversTree.walkInTree((el, startOffset) => {
                if (el.childNodes.length && el.childNodes[0].nodeName === 'MARK') {
                    return
                }
                const wordId = parseInt(el.id.split('_').at(-1))
                if (wordId in highlightMap) {
                    const highlightDetails = highlightMap[wordId]
                    const highlightId = highlightDetails.id
                    const mark = document.createElement('mark')
                    if (highlightDetails.note && wordBoxLimit.has(highlightId)) {
                        let remaining = wordBoxLimit.get(highlightId)
                        if (remaining > 0) {
                            mark.classList.add('border-b-[2px]', this.getBorderClass(highlightDetails.color))
                            wordBoxLimit.set(highlightId, remaining - 1)
                        }
                    }
                    mark.appendChild(document.createTextNode(el.textContent))
                    mark.classList.add(...this.getClass(highlightDetails.color).split(' '), 'w-full', 'h-full')
                    mark.setAttribute('data-highlight-id', highlightDetails.id)
                    mark.setAttribute('data-page-id', highlightDetails.pageId)
                    el.innerHTML = ''
                    el.appendChild(mark)
                }
            }, dom, 'SPAN')

            return dom.innerHTML
        }
    }
}
